<template>
    <div>
        <van-nav-bar v-if="!isMonitoring" left-arrow left-text="" title="尾期贷项目详情" @click-left="back" @click-right="menuActive" fixed
                     :z-index="zIndex">
            <van-icon name="weapp-nav" slot="right"/>
        </van-nav-bar>
        <van-nav-bar v-else left-arrow left-text="" title="尾期贷项目详情" @click-left="back" @click-right="menuActive" fixed
                     :z-index="zIndex">
        </van-nav-bar>
        <van-tabs v-model="active" sticky type="line" :offset-top="46">
            <van-tab title="申请详情" style="margin-top: 46px;">
                <ApplyInfo ref="applyInfoModule" :applyId="applyId"></ApplyInfo>
            </van-tab>
            <van-tab title="申请资料" style="margin-top: 46px" v-if="parseInt(auditStatus) > 49">
                <oss-apply-data ref="ossApplyDataModule" :applyId="applyId"></oss-apply-data>
            </van-tab>
            <van-tab title="预审" style="margin-top: 46px" v-if="parseInt(auditStatus) == 50" >
                <RiskFirst ref="riskFirstModule" :applyId="applyId"></RiskFirst>
            </van-tab>
            <van-tab title="预审" style="margin-top: 46px" v-if="parseInt(auditStatus) >50" >
                <PlanView ref="planViewModule" :applyId="applyId"></PlanView>
            </van-tab>
            <van-tab title="运营管理" style="margin-top: 46px" v-if="parseInt(auditStatus) >50 && tasks.length>0" >
                <Assignment ref="assignmentModule" :applyId="applyId"></Assignment>
            </van-tab>
            <van-tab title="下户" style="margin-top: 46px" v-if="surveyShow && parseInt(auditStatus) > 52 || surveyAccess &&parseInt(auditStatus) == 52">
                <oss-upload style="margin-top: 10px;" :applyId="applyId" :groupCode="903" refName="xh" :isUpload="surveyAccess"></oss-upload>
            </van-tab>
            <van-tab title="风控初审" style="margin-top: 46px" v-if="parseInt(auditStatus) > 53">
                <RiskFinal ref="riskFinalModule" :applyId="applyId" :itemType="itemType"></RiskFinal>
            </van-tab>
            <van-tab title="要件入库" style="margin-top: 46px" v-if="parseInt(auditStatus)>56">
                <Major :applyId="applyId" :isEdit="parseInt(auditStatus)==57" :backCheckAccess="backCheckAccess" :repayCheckAccess="repayCheckAccess"></Major>
            </van-tab>
            <van-tab title="还款计划" style="margin-top: 46px" v-if="parseInt(auditStatus) > 49">
                <RepayPlan ref="repayPlanModule" :applyId="applyId"></RepayPlan>
            </van-tab>
            <van-tab title="征信" style="margin-top: 46px" v-if="parseInt(auditStatus) > 52">
                <p style="padding: 10px;color: red;font-weight: bold">征信以截图的方式展示，前提是信贷网页版有生成征信截图</p>
                <oss-upload  :applyId="applyId" :groupCode="1001" refName="zxjt"></oss-upload>
            </van-tab>
            <van-tab title="审批记录" style="margin-top: 55px;" v-if="parseInt(auditStatus) > 49">
                <Records ref="recordsModule" :applyId="applyId"></Records>
            </van-tab>
        </van-tabs>

        <van-action-sheet
                v-model="menus"
                :actions="actions"
                close-on-click-action
                @select="selectAudit"
        />

        <van-dialog
                v-model="auditShow"
                :title="auditTitle"
                show-cancel-button
                :before-close="auditConfirm"
                @cancel="auditShow=false"
        >
            <van-field type="textarea" size="large" v-model="remark" :error-message="commentErr"
                       placeholder="请输入审批意见"/>
        </van-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
    import {workflow} from '@/api/loanInfo'
    import {getAssignmentList} from '@/api/foreclosure'
    import ApplyInfo from '../foreclosure/apply-info'
    import ApplyData from '../foreclosure/apply-data'
    import OssApplyData from '../foreclosure/oss-apply-data'
    import RiskFinal from '../foreclosure/risk-final-approval'
    import Contract from '../foreclosure/contract'
    import Records from '../foreclosure/records'
    import RepayPlan from '../foreclosure/repay-plan'
    import RiskFirst from '../foreclosure/risk-first'
    import PlanView from '../foreclosure/plan-view'
    import Assignment from '../foreclosure/assignment'
    import VerifyBankInfo from '../foreclosure/verify-bank-info'
    import FilesUpload from '../../business/mortgage/files-upload'
    import ossUpload from '@/views/component/oss-upload'
    import Major from '../foreclosure/major'
    import {mapGetters} from 'vuex'

    export default {
        name: 'tail_info',
        props: {},
        components: {
            ApplyInfo,
            ApplyData,
            RiskFinal,
            Contract,
            Records,
            RepayPlan,
            RiskFirst,
            PlanView,
            Assignment,
            VerifyBankInfo,
            FilesUpload,
            Major,
            OssApplyData,
            ossUpload
        },
        watch: {
            remark(val) {
                if (val.length > 0) {
                    this.commentErr = ''
                }
            }
        },
        data: function () {
            return {
                applyId: '',
                menus: false,
                auditShow: false,
                active: '0',
                outCome: '',//审批状态：通过、驳回、拒单等
                zIndex: 9,
                remark: '',
                commentErr: '',
                auditTitle: '',
                actions: [
                    {name: '通过', status: '1'},
                    {name: '驳回', status: '3'},
                    {name: '拒单', status: '5'}
                ],
                tasks:[],
                taskEffective:['PENDING','OVERTIME'], //处理中的时候允许编辑
                interViewShow:false, //有无分配面谈任务
                surveyShow:false, //有无分配下户任务
                interviewAccess:false, //面谈
                upperBankAccess:false, //核上家一押
                upperBankShow:false, //有无分配上家一押任务
                upperBankSecondAccess:false, //核上家二押
                upperBankSecondShow:false,//有无分配上家二押任务
                downBankAccess:false, //核下家
                downBankShow:false, //有无分配核下家任务
                surveyAccess:false, //下户
                itemType:'',
                repayCheckAccess:false,// 还款卡核验
                backCheckAccess:false, //回款卡核验
            }
        },
        filters: {},
        computed: mapGetters([
            'auditStatus',
            'userId',
            'isMonitoring'
        ]),
        methods: {
            menuActive() {
                //FIXME 跳到当前状态tab
                /*switch (this.auditStatus) {
                    case '10':
                        this.active = 5
                        break
                    case '2':
                        this.active = 2
                        break
                }*/
                this.menus = true
            },
            selectAudit(item, index) {
                this.outCome = item.status
                //FIXME 分发不同审批功能
                if (item.status == '1') {
                    this.auditTitle = '通过'
                } else if (item.status == '3') {
                    this.auditTitle = '驳回'
                } else if (item.status == '5') {
                    this.auditTitle = '拒单'
                }
                this.auditShow = true
            },
            back() {
                this.$router.go(-1)
            },
            toTab(index) {
                this.active = index
                this.menuShow = false

            },
            //普通审批
            auditConfirm(action, done) {
                if (action === 'confirm') {
                    if (this.remark == '') {
                        this.commentErr = '审批意见不能为空'
                        done(false)
                        return false
                    }
                    done()
                    let params = {
                        applyId: this.applyId,
                        outCome: this.outCome,
                        remark: this.remark,
                        assign: ''
                    }

                    workflow(params).then(res => {
                        if (res.success) {
                            this.$toast(res.msg)
                            this.$router.go(-1)
                        } else {
                            this.$toast(res.msg)
                        }
                    })
                } else {
                    this.commentErr = ''
                    done()
                }
            },
            switchTab(index) {
                let self = this
                setTimeout(() => {
                    self.active = index
                }, 500)
            }
        },
        mounted() {
            //初始化action(每个流程节点不同的审批功能)
            let self = this
            this.applyId = this.$route.params.id
            switch (this.auditStatus) {
                case '2':
                    self.switchTab(2)
                    break
                case '6':
                    self.switchTab(3)
                    //初始化审批表单的值
                    break
                case '10':
                    self.switchTab(5)
                    break
            }
            getAssignmentList({applyId: this.applyId}).then(res=>{
                self.tasks = res.data
                //面谈权限
                let list=[]
                list=this.tasks.filter((task => task.assignId==this.userId&&task.title=='预约面谈'&&this.taskEffective.indexOf(task.status)>-1 ))
                this.interviewAccess=list&&list.length>0
                this.interViewShow=this.tasks.filter((task => task.title=='预约面谈')).length>0
                //核上家一押权限
                list=[]
                list=this.tasks.filter((task => task.assignId==this.userId&&task.title=='核行上家一押'&&this.taskEffective.indexOf(task.status)>-1 ))
                this.upperBankAccess=list&&list.length>0
                this.upperBankShow=this.tasks.filter((task => task.title=='核行上家一押')).length>0
                //核上家二押权限
                list=[]
                list=this.tasks.filter((task => task.assignId==this.userId&&task.title=='核行上家二押'&&this.taskEffective.indexOf(task.status)>-1 ))
                this.upperBankSecondAccess=list&&list.length>0
                this.upperBankSecondShow=this.tasks.filter((task => task.title=='核行上家二押')).length>0
                //核下家权限
                list=[]
                list=this.tasks.filter((task => task.assignId==this.userId&&task.title=='核下家'&&this.taskEffective.indexOf(task.status)>-1 ))
                this.downBankAccess=list&&list.length>0
                this.downBankShow=this.tasks.filter((task => task.title=='核下家')).length>0
                //下户
                list=[]
                list=this.tasks.filter((task => task.assignId==this.userId&&task.title=='下户'&&this.taskEffective.indexOf(task.status)>-1 ))
                this.surveyAccess=list&&list.length>0
                this.surveyShow=this.tasks.filter((task => task.title=='下户')).length>0
                //还款卡核验
                list=[]
                list=this.tasks.filter((task => task.assignId==this.userId&&task.title=='还款卡核验'&&this.taskEffective.indexOf(task.status)>-1 ))
                this.repayCheckAccess=list&&list.length>0
                //回款卡核验
                list=[]
                list=this.tasks.filter((task => task.assignId==this.userId&&task.title=='回款卡核验'&&this.taskEffective.indexOf(task.status)>-1 ))
                this.backCheckAccess=list&&list.length>0
            })


        },
        destroyed() {

        }
    }
</script>

<style scope>
    .button-row {
        margin: 20px;
    }

    .button-row button {
        margin-left: 10px;
        margin-top: 10px;
    }

    .file_row .van-row {
        margin-top: 5px;
        text-align: center;
    }
</style>
